const headshots = {
  "Lori Gleria": `${process.env.PUBLIC_URL}/assets/images/headshots/LoriGleria.png`,
  'Magnificent "Mags" Farrell': `${process.env.PUBLIC_URL}/assets/images/headshots/MagsFarrell.png`,
  "Suki Wampler": `${process.env.PUBLIC_URL}/assets/images/headshots/SukiWampler.png`,
  "Marcela Salmón": `${process.env.PUBLIC_URL}/assets/images/headshots/MarcelaSalmon.jpg`,
  "Molly Bang": `${process.env.PUBLIC_URL}/assets/images/headshots/MollyBang.jpg`,
};
export default headshots;
